module.exports = __webpack_public_path__ + "img/recent-work-01.485373c6.jpg";